// extracted by mini-css-extract-plugin
export var preamble = "ArticleBody-module--preamble--eu1U8";